import { defineSlotRecipe } from '@chakra-ui/react';
import { tableAnatomy } from '@chakra-ui/react/anatomy';

const subtle = {
  root: {
    borderCollapse: 'separate',
    borderSpacing: 0,
    borderRadius: 'xl',
    overflow: 'hidden',
  },
  header: {
    bg: 'brandSecondary.muted',
  },
  columnHeader: {
    fontWeight: 'medium',
    fontSize: 'sm',
    textTransform: 'none',
  },
  body: {
    bg: 'brandSecondary.subtle',
  },
  row: {
    '&:last-of-type td': {
      borderBottomWidth: 'thin',
    },
    '& th:first-of-type': {
      borderTopLeftRadius: 'xl',
    },
    '& th:last-of-type': {
      borderTopRightRadius: 'xl',
    },
    '&:last-of-type td:first-of-type': {
      borderBottomLeftRadius: 'xl',
    },
    '&:last-of-type td:last-of-type': {
      borderBottomRightRadius: 'xl',
    },
  },
  cell: {
    color: 'text.fg',
    fontSize: 'sm',
    padding: 3,
    borderBottomWidth: 'thin',
    borderStyle: 'solid',
    borderColor: 'border.brandedDefault',
    '&:first-of-type': {
      borderLeftWidth: 'thin',
    },
    '&:last-of-type': {
      borderRightWidth: 'thin',
    },
  },
};

export default defineSlotRecipe({
  slots: tableAnatomy.keys(),
  variants: {
    variant: {
      brand: {},
      crudBrand: {},
      'brand-striped': {},
      simple: {},
      subtle,
    },
  },
  defaultVariants: {
    variant: 'brand',
  },
});
